<template>
  <div class="lesson-box cursor-pointer" @click="setLesson">
    <div class="text-lesson flex">
      <div>
        <section  v-if="item.type === 1"
        :class="{
          'circle-color': lessonSee,
          'circle-green': !lessonSee,
        }"
        class="h-3 w-3 rounded-full mr-2" />

        <section  v-else-if="item.type === 6"
     
        class="h-3 w-3 rounded-full mr-2 circle-blue" />

        <section  v-else
        :class="{
          'circle-grey': lessonSee,
        }"
        class="h-3 w-3 rounded-full mr-2" />
      </div>
      <div
        class="name-lesson text-skin-tertiary"
        :class="{ 'lesson-selected': item.id === GET_LESSON_SELECTED.id }"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="action-arrow">
      <Eye class="text-skin-secondary" v-if="item.type === 1 || item.type === 6"></Eye>
      <img
        v-else
        class="cursor-pointer"
        src="../assets/descarga.svg"
        alt=""
        srcset=""
        width="15"
        height="17"
      />
    </div>
  </div>
</template>

<script>
import Eye from "./icons/Eye.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    Eye,
  },
  computed: {
    ...mapGetters("detailCourse", ["GET_LESSON_SELECTED"]),
    lessonSee() {
      if (this.item.resource_person.length> 0)
        return false
      else 
        return true
    }
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    setLesson() {
      if (this.item.type === 1 || this.item.type === 6) {
        this.$emit("setLesson", this.item);
      } else {
        window.open(this.item.data.url, "_blank");
      }
    },
  },
};
</script>

<style scoped>
.lesson-box {
  opacity: 1;
  padding: 25px 25px 25px 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ccc;
}

.text-lesson {
  text-align: left;
  font: normal normal medium 13px Roboto !important;
  font-size: 13px !important;
  letter-spacing: 0px;
  opacity: 1;
  justify-content: flex-start;
  align-items: center;
  width: 90%;
}

.name-lesson {
  font: normal normal medium 13px Roboto !important;
}

.circle-color {
  border: 2px solid #e55974;
}
.circle-green {
  background-color: #e55974;
}

.circle-color-blue {
  border: 2px solid #3B08FC;
}
.circle-blue {
  background-color: #3B08FC;
}


.circle-grey {
  background-color: rgb(83, 83, 83);
}

.lesson-selected {
  color: #e55974 !important;
}

.number-class {
  font: normal normal normal 12px/14px Roboto;
  letter-spacing: 0px;
  color: #65676b;
  opacity: 1;
}
</style>
